export enum MonthsDateRangeType {
  One = 'one-month',
  Three = 'three-months',
  Six = 'six-months',
  Twelve = 'twelve-months',
  TwentyFor = 'twenty-for-months',
  FullHistory = 'full-history',
}
